import {
  actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { 
  jsonApiHeader, 
  showWarningMessage, 
  showErrorMessage, 
  actionCreator, 
  checkHttpStatus, 
  create_post_data, 
  createSearchUrl, 
  showSuccessMessage 
};

export const POST_CONSEQUENCES_API = `${API_URL}/api/PatientConsequencesReduction/SavePatientConsequencesReduction`;
export const GET_CONSEQUENCES_LIST_API = `${API_URL}/api/PatientConsequencesReduction/GetPatientConsequencesReduction`;
export const GET_CONSEQUENCES_DETAIL_API = `${API_URL}/api/PatientConsequencesReduction/GetPatientConsequencesReductionById`;
export const DELETE_CONSEQUENCES_API = `${API_URL}/api/PatientConsequencesReduction/DeletePatientConsequencesReduction`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const consequencesActionTypes = {
  get_masterData: createRequestActionTypes('GET_MASTERDATA'),
  save_consequences: createRequestActionTypes('SAVE_CONSEQUENCES'),
  get_consequencesList: createRequestActionTypes('GET_CONSEQUENCESLIST'),
  get_consequencesDetail: createRequestActionTypes('GET_CONSEQUENCESDETAIL'),
  delete_consequences: createRequestActionTypes('DELETE_CONSEQUENCES'),
};

export const MODULE = 'DCMASTER_CONSEQUENCESREDUCTION';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Consequences/constants/ApiConstants.js